// extracted by css-extract-rspack-plugin
var _1 = "button-bar-Y9ur8w";
var _2 = "button-bar-Y9ur8w";
var _3 = "section-HBsFRV";
var _4 = "section-title-R3ZZbE";
var _5 = "section-title-R3ZZbE";
var _6 = "table-A3pRso";
var _7 = "transitive-permissions-fdkwZF";
var _8 = "transitive-permissions-fdkwZF";
export { _1 as "button-bar", _2 as "buttonBar", _3 as "section", _4 as "section-title", _5 as "sectionTitle", _6 as "table", _7 as "transitive-permissions", _8 as "transitivePermissions" }
